import { render, staticRenderFns } from "./OrderTruckCmp.vue?vue&type=template&id=6c1bde94&scoped=true&"
import script from "./OrderTruckCmp.vue?vue&type=script&lang=js&"
export * from "./OrderTruckCmp.vue?vue&type=script&lang=js&"
import style0 from "./OrderTruckCmp.vue?vue&type=style&index=0&id=6c1bde94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bde94",
  null
  
)

export default component.exports